import { render, staticRenderFns } from "./ProductsChart.vue?vue&type=template&id=710d406e&scoped=true"
import script from "./ProductsChart.vue?vue&type=script&lang=js"
export * from "./ProductsChart.vue?vue&type=script&lang=js"
import style0 from "./ProductsChart.vue?vue&type=style&index=0&id=710d406e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710d406e",
  null
  
)

export default component.exports